import moment from 'moment';

export function getDateValue (string) {
  if (!string) return '';
  else if (string.indexOf('/') > 1) return string;

  const year = string.slice(0, 4);
  const month = string.slice(5, 7);
  const date = string.slice(8, 10);

  return `${month}/${date}/${year}`;
}

export function backToDate (string) {
  if (!string) return null;

  const month = string.slice(0, 2);
  const date = string.slice(3, 5);
  const year = string.slice(6, 10);

  return `${year}-${month}-${date}T00:00:00+00:00`;
}

export function getCurrentDate() {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  let yyyy = today.getFullYear();

  if (dd < 10) 
    dd = '0' + dd;
  
  if (mm < 10) 
    mm = '0' + mm;
  
  today = mm + '/' + dd + '/' + yyyy;
  return today;
}

export function getNext10Days() {
  var today = moment();
  var next10days = moment(today, 'DD-MM-YYYY').add(11, 'days');
  return next10days;
}

